<template>
  <div>
    <validation-provider
      v-slot="validationContext"
      name="Web Push Başlık"
      rules="required"
    >
      <b-form-group
        label="Web Push Başlık"
        label-for="campaign_name"
      >
        <b-form-input
          id="campaign_name"
          v-model="localValue.campaign_name"
          :state="getValidationState(validationContext)"
          @input="emitUpdate"
          trim
        />
        <b-form-invalid-feedback>
          {{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>
  </div>
</template>

<script>
import store from '@/store'
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BFormInvalidFeedback
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'WebPushShareForm',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BFormInvalidFeedback,
    ValidationProvider
  },
  props: {
    linkData: { type: Object, required: true },
    editingLink: { type: Object, default: null },
    startDate: { type: Object, required: true },
    endDate: { type: Object, required: true },
    platformOptions: { type: Array }
  },
  data() {
    return {
      localValue: { ...this.linkData },
      shortCodeEditMode: false
    }
  },
  watch: {
    linkData: {
      handler(newVal) {
        this.localValue = { ...newVal }
      },
      deep: true
    },
    'localValue.platform_id': function (newPlatform) {
      if (!newPlatform) return
      const selectedPlatform = this.platformOptions.find(p => p.value === newPlatform)
      if (selectedPlatform) {
        this.localValue.short_code = selectedPlatform.short_code || 'test'
        this.linkData.short_code = selectedPlatform.short_code || 'test'
      }
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update', { ...this.localValue })
    },
    getValidationState(context) {
      if (context) return context.validated ? !context.invalid : null
      return null
    }
  }
}
</script>
